export const base64FromArrayBuffer = async (
  data: BlobPart,
): Promise<string> => {
  const base64url = await new Promise<string>((resolve) => {
    const reader = new FileReader();

    reader.onload = () => resolve(reader.result as string);
    reader.readAsDataURL(new Blob([data]));
  });

  return base64url.split(',', 2)[1];
};
